
    import '/home/ec2-user/Youlify-Design/components/message/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["message-demo-hooks","message-demo-other","message-demo-duration","message-demo-loading","message-demo-thenable","message-demo-custom-style","message-demo-update","message-demo-info","message-demo-render-panel","message-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/message/index.en-US.md?type=demo')
};